import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  ["Cycle", "#cycle"],
  ["AI Nurse", "#nurse"],
  ["Rebates", "#rebates"],
  ["Creators", "#creators"],
  ["Learn", "#learn"],
];

export const Nav = ({ onSchedule }) => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 px-4 sm:px-6 pt-4">
      <nav className="glass rounded-full max-w-6xl mx-auto flex items-center justify-between pl-4 sm:pl-5 pr-2 py-2">
        <Logo />
        <div className="hidden lg:flex items-center gap-8 text-sm text-slate-300">
          {LINKS.map(([l, h]) => (
            <a key={h} href={h} data-testid={`nav-link-${l.toLowerCase().replace(" ", "-")}`} className="hover:text-white transition-colors">{l}</a>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="nav-schedule-btn" onClick={onSchedule}
            className="whitespace-nowrap rounded-full bg-[#FF2A8D] hover:bg-[#FF54A5] px-4 sm:px-5 py-2.5 text-sm font-semibold transition-colors">
            <span className="sm:hidden">Book</span><span className="hidden sm:inline">Book a test</span>
          </button>
          <button data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} className="lg:hidden p-2.5 rounded-full hover:bg-white/10" aria-label="Menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </nav>
      {open && (
        <div data-testid="mobile-menu" className="glass lg:hidden mt-2 rounded-3xl max-w-6xl mx-auto p-6 flex flex-col gap-4">
          {LINKS.map(([l, h]) => (
            <a key={h} href={h} onClick={() => setOpen(false)} className="font-display text-2xl font-bold">{l}</a>
          ))}
          <a href="#waitlist" onClick={() => setOpen(false)} className="font-display text-2xl font-bold text-duo">Join the app waitlist</a>
        </div>
      )}
    </header>
  );
};
